import { getPlaceByLatLong } from 'api/search'

export interface AccommodationSearchParams {
  checkIn: string
  checkOut: string
  destinationName: string
  destinationId: string
  adults: number | string
  children: string
  flexibleWithDate: boolean
}

export async function getAccommodationSearchParams(
  accommodationView: App.Checkout.AccommodationOfferView | undefined,
): Promise<AccommodationSearchParams | null> {
  const offer = accommodationView?.offer as App.HotelOffer | App.BedbankOffer | undefined
  if (!offer?.property || !accommodationView?.startDate || !accommodationView?.endDate) {
    return null
  }

  const place = await getPlaceByLatLong(offer.property.latitude, offer.property.longitude)
  return {
    checkIn: accommodationView.startDate,
    checkOut: accommodationView.endDate,
    destinationName: place.name,
    destinationId: place.id,
    adults: accommodationView.occupancy[0]?.adults ?? 1,
    children: 'none',
    flexibleWithDate: true,
  }
}

export function getLocationHeadingTextFromAccommodationView(accommodationView: App.Checkout.AccommodationOfferView): string {
  switch (accommodationView.offerType) {
    case 'bedbank_hotel': {
      const offer = accommodationView.offer
      const city = offer?.property.address.city
      const region = offer?.property.address.stateProvinceName ?? offer?.property.address.countryName
      return city && region ? [city, region].filter(Boolean).join(', ') : accommodationView.location ?? ''
    }
    case 'hotel': {
      const offer = accommodationView.offer
      const heading = offer?.locationHeading
      const subheading = offer?.locationSubheading
      return heading && subheading ? [heading, subheading].filter(Boolean).join(', ') : accommodationView.location ?? ''
    }
    default:
      return accommodationView.location ?? ''
  }
}
